module.exports = __webpack_public_path__ + "static/media/er.804cbebd.svg";